module.exports = __webpack_public_path__ + "components/rewards-header/static/background-ca71816f1bbf1ee0c4774b0e742118ff.mp4";